import { useTranslation } from 'react-i18next';

import { openInNewTab } from '@/utils/open-in-newtab';

export const Footer = () => {
  const { t, i18n } = useTranslation();

  const handleOnImprint = () => {
    if (i18n.language === 'EN') {
      openInNewTab('https://www.oculyze.net/legal/imprint');
    }
    if (i18n.language === 'DE') {
      openInNewTab('https://www.oculyze.net/de/rechtliches/impressum');
    }
  };

  return (
    <footer className="bg-gray">
      <div className="flex flex-col justify-between gap-4 px-4 py-8 text-lg font-semibold text-center md:text-left md:gap-0 md:py-16 md:flex-row md:px-10 md:container md:mx-auto">
        <a
          href="https://www.oculyze.net/legal/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.terms_and_conditions')}
        </a>
        <a
          href="https://www.oculyze.net/de/rechtliches/datenschutzerklaerung"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.privacy_statement')}
        </a>
        <button onClick={handleOnImprint}>{t('footer.imprint')}</button>
        <a href="mailto:support@oculyze.net?subject=&body=">{t('footer.support')}</a>
      </div>
    </footer>
  );
};
